import { render, staticRenderFns } from "./ConfigInputS3Text.vue?vue&type=template&id=dceef22a&scoped=true&"
import script from "./ConfigInputS3Text.vue?vue&type=script&lang=js&"
export * from "./ConfigInputS3Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceef22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dceef22a')) {
      api.createRecord('dceef22a', component.options)
    } else {
      api.reload('dceef22a', component.options)
    }
    module.hot.accept("./ConfigInputS3Text.vue?vue&type=template&id=dceef22a&scoped=true&", function () {
      api.rerender('dceef22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputS3Text.vue"
export default component.exports